import {
  SAVE_COMPANY,
  DOWNLOAD,
  UPLOAD,
  GET_SPOT_TO_EDIT,
  GET_NEWS_TO_EDIT,
  GET_NEWS,
  UPDATE_SPOT_DATABASE,
  SAVE_CATEGORIES,
  GET_CATEGORY_TEXT,
  SET_CATEGORY,
  SET_CATEGORY_TO_EDIT,
  GET_CATEGORY_TO_EDIT,
  SAVE_PREMIUM_PLAN,
  GET_PREMIUM_PLAN_TO_EDIT
} from "./constants";
import { take, takeEvery } from "redux-saga/effects";
import {
  saveCompany,
  download,
  upload,
  getOneNewsByKey,
  getOneSpot,
  updateSpotDatabase,
  getAllNews,
  saveCategories,
  getOneCategoryByTypeAndFields,
  savePremiumPlan,
  getOnePremiumPLan,
} from "./sagas";

export default function* rootSaga() {
  yield takeEvery(SAVE_COMPANY, saveCompany);
  yield takeEvery(DOWNLOAD, download);
  yield takeEvery(UPLOAD, upload);
  yield takeEvery(GET_NEWS, getAllNews);
  yield takeEvery(GET_NEWS_TO_EDIT, getOneNewsByKey);
  yield takeEvery(GET_SPOT_TO_EDIT, getOneSpot);
  yield takeEvery(UPDATE_SPOT_DATABASE, updateSpotDatabase);
  yield takeEvery(SAVE_CATEGORIES,saveCategories);
  yield takeEvery(GET_CATEGORY_TO_EDIT,getOneCategoryByTypeAndFields)
  yield takeEvery(SAVE_PREMIUM_PLAN,savePremiumPlan)
  yield takeEvery(GET_PREMIUM_PLAN_TO_EDIT,getOnePremiumPLan)
}
